import React, { useEffect, useState } from "react";
import BtnAddTask from "../Utilities/BtnAddTask";
import { useAppDispatch } from "../../store/hooks";
import { menusActions } from "../../store/Menu.store";
import DeleteTasks from "../AccountSection/DeleteTasks";
import { MdMenu } from "react-icons/md";
import { Route, Router, useNavigate } from "react-router-dom";
import { useAuth, useMemberstack } from "@memberstack/react";
import { setLoading } from "../../store/globalLoaderSlice";
import { CurrentUser } from "../Service/EndPoints";
import { any } from "prop-types";

const HeaderTasks: React.FC = () => {
  const { userId, signOut, isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [navbarOpen, setNavbarOpen] = React.useState(false);
  const logout = () => {
    localStorage.clear();
    sessionStorage.clear();

   // window.location.href = "/";
   dispatch( setLoading(true));
    navigate("/logout");
    signOut();

  };

  

  const toggalNavbarOpen = () => {
    setNavbarOpen(()=>!navbarOpen);
  };
  const openMenuAccountHandler = () => {
    dispatch(menusActions.openMenuAccount());
  };

  const memberstack = useMemberstack();
  
  useEffect(()=>{
  
    memberstack.getPlans().then(({ data: plans }) => {
     let filterPlans :any =  [];
     CurrentUser().planConnections.forEach((ue:any) => {
        plans.forEach((p: any) => {
          if ( p.id === ue.planId) {
            filterPlans.push(p)
          }
        });
      });
      localStorage.setItem("loggedinuserplans",JSON.stringify( filterPlans));
 });

  },[memberstack]);
  return (
    <>
      <nav className="relative  flex flex-wrap items-center justify-between px-2 py-3  mb-3">
        <div className="container  mx-auto  flex flex-wrap items-center justify-between  flex-grow  w-full">
          <div className="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
            <div className="lg:w-96 flex-col justify-center items-start gap-px inline-flex">
              <div className="self-stretch justify-start items-center gap-4 inline-flex">
                <div className="w-8 h-8 relative">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M23.0813 25.3592L25.157 26.4329L25.1567 26.4221C25.3635 26.5286 25.4427 26.7807 25.3349 26.985C25.2271 27.1893 24.9719 27.2686 24.7651 27.1621L22.6729 26.0798L21.6586 25.5234C21.1614 25.2365 20.7247 24.8594 20.3716 24.4106C20.002 23.9314 19.804 23.3446 19.8084 22.7414V22.6165C18.7679 23.6369 17.3686 24.2205 15.9023 24.2465C14.48 24.2237 13.1192 23.6728 12.0896 22.7023V22.7414C12.0951 23.3446 11.8971 23.9314 11.5264 24.4106C11.1733 24.8594 10.7366 25.2365 10.2394 25.5234L9.26254 26.0798L7.1472 27.1763C6.94042 27.2828 6.6852 27.2034 6.5774 26.9991C6.46961 26.7949 6.5488 26.5427 6.7567 26.4362L8.84895 25.3539L9.80596 24.7975C10.2119 24.5628 10.5694 24.2531 10.8565 23.8847C11.1128 23.5576 11.2525 23.1555 11.2536 22.7415V21.8091C10.6761 21.081 10.2141 20.2692 9.88517 19.4031C8.45735 18.6098 7.61253 17.5394 7.61253 16.343V10.2227C7.60155 9.82713 7.75885 9.44461 8.04595 9.16859C8.48486 8.73936 9.22298 8.51224 10.2031 8.39488C11.3847 6.3867 13.5583 5.15112 15.9101 5.15112C18.261 5.15112 20.4346 6.38664 21.6171 8.39488H21.616C22.6754 8.50899 23.4641 8.73719 23.9228 9.18818C24.2044 9.45986 24.3595 9.8337 24.3507 10.2227V16.3516C24.3507 17.597 23.4212 18.7076 21.9009 19.503C21.5929 20.2865 21.1771 21.0244 20.6645 21.6949V22.7414C20.6667 23.1587 20.8097 23.5629 21.0704 23.89C21.3542 24.2573 21.7051 24.567 22.1067 24.8028L23.0813 25.3592ZM23.5059 10.2226C23.5114 10.0574 23.4443 9.89873 23.3233 9.78571C22.9658 9.51511 22.5378 9.34884 22.0901 9.30755C22.3475 9.91176 22.5191 10.5486 22.5994 11.1995C23.1902 10.8735 23.5059 10.529 23.5059 10.2226ZM15.9114 5.99644C17.7408 6.00731 19.4568 6.86906 20.5435 8.32307C20.7558 8.59692 20.944 8.88814 21.1068 9.19351C21.4049 9.76404 21.6128 10.3769 21.7206 11.0094C21.7525 11.1952 21.7756 11.3799 21.791 11.5658C21.5897 11.6418 21.3719 11.7146 21.1376 11.7831C19.46 12.2384 17.7253 12.4558 15.985 12.4286C14.2008 12.459 12.4233 12.2297 10.7072 11.7472C10.4685 11.6734 10.2485 11.5962 10.045 11.5169C10.0593 11.3473 10.0846 11.1778 10.1121 11.0105L10.1132 11.0094C10.221 10.3791 10.4278 9.76838 10.7248 9.19895C10.8865 8.8914 11.0746 8.59799 11.288 8.32308C12.3726 6.87123 14.0854 6.00949 15.9114 5.99644ZM9.72715 9.33265C9.33112 9.37939 8.95493 9.5337 8.64032 9.77712C8.51821 9.89341 8.4522 10.0553 8.4577 10.2227C8.4577 10.5008 8.72832 10.8269 9.24312 11.13C9.32344 10.5117 9.48624 9.90751 9.72715 9.33265ZM9.48515 18.1229C8.83504 17.5948 8.45774 16.9884 8.45774 16.3451V11.6136C8.68105 11.7776 8.91975 11.9211 9.16945 12.0417C9.31905 12.1145 9.47304 12.1841 9.64026 12.2504C9.80636 12.3167 9.89106 12.3482 10.0231 12.3949C10.0988 12.4223 10.1803 12.4483 10.2605 12.4739C10.3202 12.4929 10.3791 12.5117 10.4345 12.5307V12.5318C12.2385 13.0371 14.1063 13.2827 15.9818 13.2632C17.8123 13.2806 19.6371 13.048 21.4027 12.5709C21.4999 12.5428 21.5953 12.512 21.6895 12.4815C21.7265 12.4695 21.7633 12.4576 21.7998 12.446C21.9296 12.4047 22.0815 12.3514 22.2003 12.3014C22.2321 12.2881 22.2691 12.2729 22.309 12.2565C22.4183 12.2117 22.5496 12.1578 22.6568 12.1069L22.6557 12.1058C22.9538 11.9689 23.2365 11.8037 23.5005 11.6103V16.343C23.5005 17.0417 23.0561 17.6981 22.2982 18.2566C21.9638 18.499 21.6063 18.7087 21.2311 18.8826C19.5756 19.6009 17.7837 19.9584 15.9764 19.9291C14.1168 19.9291 11.7026 19.4063 10.5555 18.7989C10.2461 18.6351 9.63327 18.2566 9.48515 18.1229ZM12.0931 21.5145C13.124 22.6936 14.455 23.4086 15.9114 23.4086C17.9146 23.4086 19.541 21.7689 19.8989 21.3309C20.2046 20.9568 20.5151 20.4752 20.758 19.9986C19.2247 20.5245 17.611 20.7843 15.9873 20.7658C14.3019 20.7864 12.6256 20.5039 11.0426 19.9312C11.2604 20.3637 11.5178 20.7756 11.8115 21.1613C11.8227 21.176 11.8332 21.1898 11.8432 21.2029C11.9486 21.3415 11.9934 21.4004 12.0931 21.5145Z"
                      fill="#06B4FF"
                    />
                    <path
                      d="M23.6492 23.6241C22.991 25.1276 19.797 26.2682 15.9561 26.2682C11.6386 26.2682 8.13867 24.827 8.13867 23.0493C8.13867 22.0884 9.16126 21.2258 10.7828 20.636"
                      stroke="#E4EFF9"
                      stroke-width="0.689768"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M24.0031 23.6591C24.6381 23.6591 25.1528 23.1444 25.1528 22.5095C25.1528 21.8746 24.6381 21.3599 24.0031 21.3599C23.3682 21.3599 22.8535 21.8746 22.8535 22.5095C22.8535 23.1444 23.3682 23.6591 24.0031 23.6591Z"
                      stroke="#E4EFF9"
                      stroke-width="0.689768"
                    />
                    <path
                      d="M11.876 21.2434C11.8658 21.23 11.855 21.2158 11.8435 21.2007L11.8119 21.1591C11.5557 20.8226 11.3272 20.4663 11.1284 20.0938H10.1744C10.3905 20.5404 10.6387 20.9417 10.8426 21.2434H11.876Z"
                      fill="#06B4FF"
                    />
                    <path
                      d="M10.2084 16.7501V13.7526C11.191 14.1273 12.4683 14.6893 15.9073 14.6893C18.9533 14.6893 20.8202 14.1273 21.7046 13.6589V16.7501C20.722 17.7805 18.5014 18.4873 15.9073 18.4873C13.3133 18.4873 10.8962 17.6868 10.2084 16.7501Z"
                      fill="url(#paint0_linear_1_866)"
                    />
                    <rect
                      opacity="0.1"
                      x="4"
                      y="11.1282"
                      width="2.38683"
                      height="2.3868"
                      fill="#E0F0FF"
                    />
                    <rect
                      opacity="0.4"
                      x="4"
                      y="14.2297"
                      width="2.38683"
                      height="2.3868"
                      fill="#E0F0FF"
                    />
                    <rect
                      opacity="0.7"
                      x="4"
                      y="17.334"
                      width="2.38683"
                      height="2.3868"
                      fill="#E0F0FF"
                    />
                    <rect
                      x="4"
                      y="20.4355"
                      width="2.38683"
                      height="2.3868"
                      fill="#E0F0FF"
                    />
                    <rect
                      opacity="0.1"
                      x="25.6133"
                      y="4"
                      width="2.38683"
                      height="2.3868"
                      fill="#E0F0FF"
                    />
                    <rect
                      opacity="0.4"
                      x="25.6133"
                      y="7.10156"
                      width="2.38683"
                      height="2.3868"
                      fill="#E0F0FF"
                    />
                    <rect
                      opacity="0.7"
                      x="25.6133"
                      y="10.2058"
                      width="2.38683"
                      height="2.3868"
                      fill="#E0F0FF"
                    />
                    <rect
                      x="25.6133"
                      y="13.3074"
                      width="2.38683"
                      height="2.3868"
                      fill="#E0F0FF"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_1_866"
                        x1="15.7495"
                        y1="14.9666"
                        x2="21.7659"
                        y2="15.11"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#06B4FF" />
                        <stop offset="1" stop-color="#78D6FF" />
                        <stop offset="1" stop-color="#78D6FF" />
                        <stop offset="1" stop-color="#78D6FF" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <div className="text-sky-100 text-lg  leading-relaxed">
                  7X Investors Strategy Portal
                </div>
              </div>
            </div>

            <button
              className="text-white cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
              type="button"
              onClick={() => setNavbarOpen(!navbarOpen)}
            >
              <MdMenu size={25} />
            </button>
          </div>
          <div
            className={
              "lg:flex flex-grow items-center" +
              (navbarOpen ? " flex" : " hidden")
            }
            id="example-navbar-danger"
          >
            <ul className={`flex flex-col lg:flex-row list-none ${navbarOpen?" mt-4 ":" "}  lg:ml-auto`}>
              <li className="nav-item">
                {/* <div className="py-2  float-right">
                  <DeleteTasks />
                </div> */}
              </li>
              <li className="nav-item">
                <div className="float-right">
                  <BtnAddTask
                    icon={true}
                    className="  place-content-center bg-transparent text-[#E4EFF9]   border-[#06B4FF] border dark:shadow-slate-900 "
                  />
                </div>
              </li>
              <li className="nav-item">
                <div className={`mr-0  ${navbarOpen?" ml-0 my-2 ":" ml-2 my-0 " } lg:ml-2 lg:my-0    bg-transparent    hover:text-[#000000] text-[#E4EFF9]   border-[#06B4FF] border dark:shadow-slate-900 h-[48px] ga`}>
                  <button
                    onClick={ logout}
                    className="text-[#E4EFF9]     inline-flex items-center px-4 py-2"
                  >
                    <span className=" mr-4">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17 16L21 12M21 12L17 8M21 12H7M13 16V17C13 18.6569 11.6569 20 10 20H6C4.34315 20 3 18.6569 3 17V7C3 5.34315 4.34315 4 6 4H10C11.6569 4 13 5.34315 13 7V8" stroke="#E4EFF9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

                    </span>
                    Logout
                  </button>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default HeaderTasks;
